import { render } from "./aio-login-metadata.vue?vue&type=template&id=22d2a4f8&scoped=true"
import script from "./aio-login-metadata.vue?vue&type=script&lang=js"
export * from "./aio-login-metadata.vue?vue&type=script&lang=js"

import "./aio-login-metadata.vue?vue&type=style&index=0&id=22d2a4f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d2a4f8"]])

export default __exports__